import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import SignOut from "../components/SignOut";
import { Link } from "react-router-dom";
import { getWatchlist, getLikedlist } from "../services/firebase";
import { useNavigate } from "react-router-dom";
import "./Profile.scss";

const Profile = () => {
    const { user, loading } = useAuth();
    const [watchlistCount, setWatchlistCount] = useState(null);
    const [likedlistCount, setLikedlistCount] = useState(null);
    const [loadingList, setLoadingList] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLists = async () => {
            try {
                if (user) {
                    const watchList = await getWatchlist(user.uid);
                    setWatchlistCount(watchList.length);
                    const likedList = await getLikedlist(user.uid);
                    setLikedlistCount(likedList.length);
                    setLoadingList(false);
                } else {
                    navigate("/signin");
                }
            } catch (error) {
                console.error("Failed to fetch lists: ", error);
            }
        };
        fetchLists();
    }, [user, navigate]);

    return (
        <div className="profile layout">
            <h1>Profile</h1>
            {loading ? (
                <p>Loading...</p>
            ) : (
                user && (
                    <>
                        <div className="user">
                            <div className="details">
                                <img
                                    src={user.photoURL}
                                    alt={user.displayName}
                                />
                                <h2>{user.displayName}</h2>
                            </div>
                            <SignOut />
                        </div>
                        <div className="lists">
                            {loadingList ? (
                                <p>Loading...</p>
                            ) : (
                                <>
                                    <Link className="list_item" to="/watchlist">
                                        <h3>Watchlist({watchlistCount})</h3>
                                    </Link>
                                    <Link
                                        className="list_item"
                                        to="/likedmovies"
                                    >
                                        <h3>Liked Movies({likedlistCount})</h3>
                                    </Link>
                                </>
                            )}
                        </div>
                    </>
                )
            )}
        </div>
    );
};

export default Profile;
